import React from 'react';
import { FiAward } from 'react-icons/fi';
import Reveal from '../fx/Reveal';
import CascadeGrid from '../fx/CascadeGrid';

const certifications = [
    { name: 'LPT Master', logo: '/cert-logos/lpt.png' },
    { name: 'CPENT', logo: '/cert-logos/cpent.png' },
    { name: 'PNPT', logo: '/cert-logos/pnpt.png' },
    { name: 'Pentest+', logo: '/cert-logos/pentest+.png' },
    { name: 'CEH', logo: '/cert-logos/ceh.png' },
    { name: 'CRTO', logo: '/cert-logos/crto.png' },
    { name: 'CPTS', logo: '/cert-logos/cpts.png' },
    { name: 'BSCP', logo: '/cert-logos/bscp.png' },
];

// Additional certs held by the team (display as text pills, no separate logo art).
const additionalCerts = [
    'CISSP', 'CCT', 'eWPTX', 'eMAPT', 'CRTA', 'Security+', 'CNVP',
    'CAP', 'CAPen', 'CMPA', 'PT1', 'SC-200', 'IRM', 'CSMP',
];

const achievements = [
    { title: 'ASEAN Cyber Shield 2023', result: '2nd Place', medal: '🥈' },
    { title: 'ASCIS Vietnam 2022', result: 'Finalist', medal: '🏅' },
    { title: 'BPJS HEALTHKATHON 2023', result: '1st Place', medal: '🥇' },
    { title: 'HackTheon Sejong Korea 2024', result: 'Finalist', medal: '🏅' },
    { title: 'CyberSec Hackathon 2022', result: '1st Place', medal: '🥇' },
    { title: 'uConnect CTF 2023', result: '1st Place', medal: '🥇' },
    { title: 'TechComfest 2024', result: '1st Place', medal: '🥇' },
    { title: 'Cyber SEA Game 2024', result: '3rd Place', medal: '🥉' },
    { title: 'and many more', result: '', medal: '🏆' },
];

const TrainerCertifications = () => {
    return (
        <section className="relative bg-[#08090f] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute inset-0 bg-dots opacity-20 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto">
                {/* Certifications */}
                <Reveal className="text-center mb-12">
                    <span className="pill tag inline-flex mb-4">CERTIFICATIONS</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold">
                        Team's <span className="text-gradient-red">credentials</span>
                    </h2>
                    <p className="text-gray-400 max-w-2xl mx-auto mt-3 text-lg">
                        Globally recognized practitioners holding the industry's most advanced certifications.
                    </p>
                </Reveal>

                <CascadeGrid className="flex flex-wrap justify-center gap-4 mb-10" stagger={60}>
                    {certifications.map((c, i) => (
                        <div key={i} className="card p-5 flex flex-col items-center w-40">
                            <img src={c.logo} alt={c.name} className="h-20 mb-3 object-contain" />
                            <p className="text-sm text-center font-semibold">{c.name}</p>
                        </div>
                    ))}
                </CascadeGrid>

                {/* Additional certs without dedicated logo art */}
                <Reveal className="mb-20">
                    <p className="text-xs font-mono uppercase tracking-widest text-gray-500 text-center mb-4">Plus additionally held</p>
                    <div className="flex flex-wrap justify-center gap-2 max-w-4xl mx-auto">
                        {additionalCerts.map((name) => (
                            <span key={name} className="px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-gray-200 text-sm font-mono">
                                {name}
                            </span>
                        ))}
                    </div>
                </Reveal>

                {/* Achievements */}
                <Reveal className="text-center mb-12">
                    <span className="pill tag inline-flex mb-4">ACHIEVEMENTS</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold">
                        Team's <span className="text-gradient-red">trophy case</span>
                    </h2>
                    <p className="text-gray-400 max-w-2xl mx-auto mt-3 text-lg">
                        Consistent elite-level performance across international CTFs and security contests.
                    </p>
                </Reveal>

                <CascadeGrid className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" stagger={90}>
                    {achievements.map((a, i) => (
                        <div key={i} className="card p-6 relative overflow-hidden">
                            <div className="absolute top-4 right-5 text-6xl opacity-15 pointer-events-none">{a.medal}</div>
                            <div className="flex items-center gap-3 mb-3 relative">
                                <FiAward className="text-red-400" />
                                <h3 className="font-display font-semibold text-base">{a.title}</h3>
                            </div>
                            {a.result && (
                                <div className="text-gradient-red font-bold font-display text-lg relative">{a.result}</div>
                            )}
                        </div>
                    ))}
                </CascadeGrid>
            </div>
        </section>
    );
};

export default TrainerCertifications;
